import React, { useContext } from "react";
import { useSiteConfig } from "../context/SiteConfigContext";
import { Link } from "react-router-dom";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaLinkedin,
  FaCode,
} from "react-icons/fa";
import { CategoryContext } from "../context/CategoryContext";

function Footer() {
  const { config } = useSiteConfig();
  const { categories } = useContext(CategoryContext);

  return (
    <>
      






       <footer className="ith-footer-section">
      <div className="container-fluid px-lg-5 pt-4">
        <div className="row g-4">
          
          {/* Column 1: Logo & About */}
          <div className="col-lg-3 col-md-6">
            <div className="ith-footer-widget">
              <div className="ith-footer-logo-wrapper d-flex align-items-center mb-4">
                <img src={config?.logo}alt="Logo" className="ith-footer-logo ith-rotate-logo-360" />
                <div className="ms-3">
                  <h4 className="ith-footer-brand">ITH GROUP</h4>
                  <p className="ith-footer-tagline">Industrial Trading House</p>
                </div>
              </div>
              <p className="ith-footer-desc">
                Founded in 1998, We Offer Complete Hydraulic Solutions.
              </p>
              <h2 className="ith-footer-since-text">Since 1998</h2>
            </div>
          </div>

          {/* Column 2: Useful Links */}
          <div className="col-lg-3 col-md-6">
            <div className="ith-footer-widget ps-lg-5">
              <h5 className="ith-footer-title">Useful Links</h5>
              <div className="row">
                <div className="col-6">
                  <ul className="ith-footer-links">
                    <li><a href="/about-us">About Us</a></li>
                    <li><a href="/privacy-policy">Privacy Policy</a></li>
                    <li><a href="/contact-us">Contact</a></li>
                  </ul>
                </div>
                <div className="col-6">
                  <ul className="ith-footer-links">
                    <li><a href="/careers">Careers</a></li>
                    <li><a href="/services">Services</a></li>
                    <li><a href="/terms">Terms of use</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Column 3: Address & Email */}
          <div className="col-lg-3 col-md-6">
            <div className="ith-footer-widget">
              <h5 className="ith-footer-title">Office Address</h5>
              <p className="ith-footer-info-text">
                SCO 43, Emperor Square, TDI City,<br />
                Kundli, Sonepat, Haryana, 131028
              </p>
              <h5 className="ith-footer-title mt-4">Email Address</h5>
              <div className="ith-footer-emails">
                <a href="mailto:ith.hydraulics@gmail.com">ith.hydraulics@gmail.com</a>
                <a href="mailto:vishal@ithgroup.in">vishal@ithgroup.in</a>
                <a href="mailto:ruchi@ithgroup.in">ruchi@ithgroup.in</a>
              </div>
            </div>
          </div>

          {/* Column 4: Phone & Social */}
          <div className="col-lg-3 col-md-6">
            <div className="ith-footer-widget">
              <h5 className="ith-footer-title">Phone Number</h5>
              <div className="ith-footer-phones">
                <a href="tel:+919711130355">+91-9711130355</a>
                <a href="tel:+919910007108">+91-9910007108</a>
              </div>
              <h5 className="ith-footer-title mt-4">Follow Us</h5>
              <div className="ith-footer-social">
                 {config?.socialMedia?.facebook && (
                  
                    <a
                      href={config.socialMedia.facebook}
                      target="_blank"
                      className="ith-social-box"
                    >
                      <FaFacebook size={16} />
                    </a>
                 
                )}
                  {config?.socialMedia?.instagram && (
                 
                    <a
                      href={config.socialMedia.instagram}
                      target="_blank"
                      className="ith-social-box"
                    >
                      <FaInstagram size={16} />
                    </a>
                  
                )}
                {config?.socialMedia?.twitter && (
                 
                    <a
                      href={config.socialMedia.twitter}
                      target="_blank"
                      className="ith-social-box"
                    >
                      <FaTwitter size={16} />
                    </a>
                  
                )}
                {config?.socialMedia?.youtube && (
                  
                    <a
                      href={config.socialMedia.youtube}
                      target="_blank"
                      className="ith-social-box "
                    >
                      <FaYoutube size={16} />
                    </a>
                  
                )}
              </div>
            </div>
          </div>

        </div>
      </div>
      

  <div className="footer-bottom mt-5 pt-4 border-top">
            <Row className="align-items-center">
              <Col md={6} className="text-start ps-5">
                <p className="mb-0 footer-text">
                  All Rights Reserved © 2026 ITH 
                </p>
              </Col>
              <Col md={6} className="text-end">
                <a
                  href="https://axesell.com"
                  className="floating-designer-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="floating-content">
                    <img
                      src="/images/axesell_logo.png"
                      className="floating-icon"
                      alt="Axesell"
                    />
                  </div>
                </a>
              </Col>
            </Row>
          </div>
    </footer>
    </>
  );
}

export default Footer;
